/* hints.js — tiny, Firebase-free signals the apps leave for the landing page.
 * The landing bundle deliberately ships without Firebase, so it personalizes
 * off these localStorage hints instead of real auth state. Hints affect
 * PROMINENCE only — /admin still does real auth and /player still resumes for
 * real, so a stale hint costs at most one extra sign-in screen. */

const HOST_HINT_KEY = 'cabin-pinochle-host-v1';
// written by playerStore.js (its PERSIST_KEY) — read here so the landing can
// offer "return to your game" without loading the player bundle
const PLAYER_SESSION_KEY = 'cabin-pinochle-player-v2';

// the signed-in host's email, or null — written by the console on sign-in,
// cleared only on explicit sign-out (a player session on the same device must
// not erase the host's shortcut)
export function hostHint() {
  try { return localStorage.getItem(HOST_HINT_KEY); } catch { return null; }
}
export function setHostHint(email) {
  try { localStorage.setItem(HOST_HINT_KEY, email); } catch { /* private mode */ }
}
export function clearHostHint() {
  try { localStorage.removeItem(HOST_HINT_KEY); } catch { /* private mode */ }
}

// a live player join on this device (tournament or game) that resume() can restore
export function hasPlayerSession() {
  try { return !!JSON.parse(localStorage.getItem(PLAYER_SESSION_KEY))?.tid; } catch { return false; }
}
